import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { Button } from '../../ui/button';
import { STAGE_OPTIONS_MAP } from './deal-stage-selector';

export const DealStageBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
}: {
  value: Deal['stage'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
}) => {
  const option = STAGE_OPTIONS_MAP.find((option) => option.value === value);

  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Contract Status</p>
        </>
      )}
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {STAGE_OPTIONS_MAP.find((option) => option.value === value)?.label}
        </p>
      )}
    </Button>
  );
};
